const state = {
  visibleServicesAndLayers: {},
  fieldsOfLayers: {},
  currentLayerKey: null,
}

const getters = {
  getVisibleServicesAndLayers: state => state.visibleServicesAndLayers,
  getFieldsOfLayers: state => state.fieldsOfLayers,
  getCurrentLayerKey: state => state.currentLayerKey,
}

const mutations = {
  updateVisibleServicesAndLayers (state, payload) {
    state.visibleServicesAndLayers = {
      ...state.visibleServicesAndLayers,
      [payload.id]: payload.layers,
    }
  },
  updateFieldsOfLayers (state, payload) {
    state.fieldsOfLayers = {
      ...state.fieldsOfLayers,
      [payload.id]: payload.fields,
    }
  },
  updateCurrentLayerKey (state, payload) {
    state.currentLayerKey = payload
  },
}

const actions = {
  updateVisibleServicesAndLayers ({ commit }, payload) {
    commit('updateVisibleServicesAndLayers', payload)
  },
  updateFieldsOfLayers ({ commit }, payload) {
    commit('updateFieldsOfLayers', payload)
  },
  updateCurrentLayerKey ({ commit }, payload) {
    commit('updateCurrentLayerKey', payload)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
